import type {z as zod} from "zod";
import type {Result} from "@vesta/error-handling-remix/result";
import {errorResult, dataResult} from "@vesta/error-handling-remix/result";
import {getErrorFromUnknown} from "@vesta/global-common-typescript/utilities/typeValidationUtilities";

// Assumes API returns response in the shape of T, with a status code of 200
export async function robustServerFetch<T>(
    requestUrl: string,
    requestOptions: RequestInit,
    responseValidator: zod.ZodSchema<T>,
): Promise<Result<T>> {
    try {
        // logToWinston(
        //     LogLevel.debug,
        //     "Sending new request to ${requestUrl}",
        //     {
        //         requestUrl: requestUrl,
        //     },
        //     ["Fetch Events", "${requestUrl}"],
        // );

        const response = await fetch(requestUrl, requestOptions);

        const responseText = await response.text();

        // logToWinston(
        //     LogLevel.debug,
        //     "Response = ${responseBodyText}",
        //     {
        //         requestUrl: requestUrl,
        //         responseBodyText: responseText,
        //     },
        //     ["Fetch Events", "${requestUrl}"],
        // );

        if (response.ok === false) {
            // logToWinston(
            //     LogLevel.error,
            //     "Error communicating with backend: Status code not in 2xx or 3xx; response status = ${responseStatusCode}, response body = ${responseBodyText}",
            //     {
            //         requestUrl: requestUrl,
            //         responseStatusCode: response.status,
            //         responseBodyText: responseText,
            //     },
            //     ["Fetch Events", "${requestUrl}"],
            // );

            throw new Error("Error communicating with backend!");
        }

        const responseValidatorResult =
            responseValidator.safeParse(responseText);
        if (responseValidatorResult.success === false) {
            // logToWinston(
            //     LogLevel.error,
            //     "Error communicating with backend: response validation failed; response status = ${responseStatusCode}, response body = ${responseBodyText}, validation error = ${error}",
            //     {
            //         requestUrl: requestUrl,
            //         responseStatusCode: response.status,
            //         responseBodyText: responseText,
            //         error: responseValidatorResult.error,
            //     },
            //     ["Fetch Events", "${requestUrl}"],
            // );

            throw new Error("Error communicating with backend!");
        }
        const responseObject = responseValidatorResult.data;

        return dataResult(responseObject);
    } catch (exception) {
        const error = getErrorFromUnknown(exception);
        return errorResult(error);
    }
}
